import { render } from "./AcceptChatInviteNotification.vue?vue&type=template&id=b9b9232a"
import script from "./AcceptChatInviteNotification.vue?vue&type=script&lang=js"
export * from "./AcceptChatInviteNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__